export default __webpack_public_path__ + "static/media/zip-icon.e2bf9c21.svg";